<script>

const { listpage } = require('@/vue-model-mirror');

export default {
    name: 'item-list',
    extends: listpage,
    watch: {
        hash( new_val, old_val ) {
            if ( old_val ) {
                console.log('reload');
                if ( this.$refs.hasOwnProperty('listbnv') ) {
                     var options = this.$refs.listbnv.get_qry_filters();
                     this.$refs.listbnv.load_rows( { options } );
                }
            }
        },
    },
    computed: {
        hash() { return this.$store.state.item.hash },
        page() { return this.$store.state.item.page },
//      filters: {
//          get : function() {
//              return this.$store.state.item.filters;
//          },
//          set : function (filters) {
//              this.$store.dispatch('item/set_filters', filters);
//          }
//      },
    },
    methods: {
        check_string() {
            try {
                var options = this.$refs.listbnv.get_qry_filters();
            } catch ( error ) { return; }
            this.$store.dispatch('item/check_string', { options });
            setTimeout( () => {
                this.check_string();
            }, this.timeout_refresh );
        },
        submit_search_form() {
            this.$refs.search_form.submit_form();
        },
        clear_search_form( modal_event ) {
            if ( modal_event.trigger === 'clear' ) {
                this.reset_search_form();
                this.$refs.search_form.submit_form();
            }
        },
        toggle_modal(modal_id = 'modal-filter') {
            this.$root.$emit('bv::toggle::modal', modal_id);
        },
        search( data ) {
            Object.keys( data ).map( x => {
                if ( data[ x ] === null ) {
                    this.$store.dispatch('item/remove_filter', x);
                    delete this.filters[ x ];
                } else {
                    var filter = {};
                    filter[ x ] = typeof data[ x ] === 'object' ? data[ x ].search : data[ x ];
                    if ( [ 'first_name', 'last_name', 'title',  ].includes( x ) ) {
                        filter[ x ] = `|${ filter[x] }|`;
                    } else if ( x === 'created__lte' ) {
                        filter[ x ] += 'T23:59:59';
                    } else if ( x === 'created__gte' ) {
                        filter[ x ] += 'T00:00:00';
                    }
                    this.$store.dispatch('item/add_filter', filter);
                    this.filters[ x ] = data[ x ];
                }
            }); 
            this.toggle_modal();
            this.$refs.listbnv.page = 1;
        },
    },
    created() {
        setTimeout( () => {
            this.check_string()
        }, this.timeout_refresh );
    },
    data() {
        return { 
            timeout_refresh  : 60000,
            modal_filter_key : 0,
            filters          : {},
        };
    },
};

</script>

<template>

    <div style="width: 100%; margin: auto">
        <h3 style="text-align: center; padding-bottom: 14px;">{{ title }}</h3>
        <b-row style="margin-bottom: 10px" align-h="between">
            <b-col v-if="add" align-self="end" class="text-left">
                <b-button @click="toggle_modal()" style="padding-top: 6px" size="sm" variant="outline-primary"><icon name="filter"/></b-button>
                <b-button  v-b-modal.modal-legend style="margin-left: 20px; padding-top: 6px" size="sm" variant="outline-dark"><icon name="question"/></b-button>
            </b-col>
            <b-col v-if="add" align-self="end" class="text-right">
                <b-button @click="new_element();" style="padding-top: 6px" size="sm" variant="outline-info"><icon name="plus"/></b-button>
            </b-col>
        </b-row>
        <bnvlist
            :schema          = "schema_name"
            storename        = "bnvform"
            :skip            = "skip"
            :fields          = "fields"
            :primarykey      = "primary_key"
            :qryoptions      = "qry_options"
            :details         = "details"
            :detailsclass    = "details_class"
            :detailsaction   = "details_action"
            :edit            = "edit"
            :editaction      = "edit_action"
            :paginate        = "paginate"
            :link            = "link"
            :rowclass        = "rowclass"
            :linkfunction    = "linkfunction"
            :initialfilter   = "initialfilter"
            ref              = "listbnv"
            :size            = "size"
            :formpath        = "item_form"
            @row_selected    = "row_selected"
            @right-click     = "right_click"
        ></bnvlist>

        <!-- modal filtri -->
        <b-modal
            id="modal-filter"
            title="Filtri"
            @hide="clear_search_form"
            button-size="sm"
            >
            <bnvform
                v-if       = "search_schema"
                :key       = "modal_filter_key"
                :name      = "search_schema"
                :schema    = "schema"
                :options   = "form_config"
                :record    = "filters"
                :submit    = "false"
                :inline    = "inline"
                ref        = "search_form"
                @submitted = "search"
            ></bnvform>
            <template v-slot:modal-footer="{ ok, cancel, hide }">
                <b-row><b-col>
                    <b-button size="sm" variant="success" @click="submit_search_form">
                      OK
                    </b-button>
                </b-col><b-col>
                    <b-button size="sm" variant="warning" @click="hide('clear')">
                      Reset
                    </b-button>
                </b-col><b-col>
                    <b-button size="sm" variant="outline-secondary" @click="cancel()">
                      Chiudi
                    </b-button>
                </b-col></b-row>
            </template>
        </b-modal>

        <b-modal id="modal-legend" button-size="sm" :ok-only="true"  title="Legenda">
            <p><b-badge variant="info">inviato</b-badge><br/>Il documento e tutti i dati associati sono stati inviati con successo al client. Il client si occuperà della validazione e dell'invio al nodo. Questa fase solitamente ha una durata di circa 15 minuti.</p>
            <p><b-badge variant="primary">salvato</b-badge><br/>Il documento è stato inviato con successo al nodo. Da questo momento il link associato al QRCode è attivo e il documento è in attesa della notarizzazione. Per la notarizzazione possono essere necessarie fino a 12 ore.</p>
        </b-modal>

    </div>

</template>



